<p>
  base-modal-page works!
</p>
